import { render, staticRenderFns } from "./middleTop.vue?vue&type=template&id=5af445ca&scoped=true&"
import script from "./middleTop.vue?vue&type=script&lang=js&"
export * from "./middleTop.vue?vue&type=script&lang=js&"
import style0 from "./middleTop.vue?vue&type=style&index=0&id=5af445ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af445ca",
  null
  
)

export default component.exports